import {ISorting} from "../types/generalTypes";

export const createGetUsersQuery = (
    pageNumber: number,
    itemsPerPage: number,
    sorting: ISorting,
    searchValue: string | null
) => {
    let query = `?PageNum=${pageNumber}&PageSize=${itemsPerPage}`

    if (sorting.criteria) {
        query += `&Sort=${+sorting.isAscending}&SortField=${sorting.criteria}`
    }

    if (searchValue) {
        query += `&Search=${searchValue}`
    }

    return query
}
